import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { InputSwitch } from "primereact/inputswitch";
import { portefeuillesService } from "../../services";
import { Loading, showToast } from "..";
import { Actif, User } from "../../interfaces";
import { MultiSelect } from "primereact/multiselect";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../utils/UserProvider";
import { AWS_BUCKET_ENV,AWS_BUCKET_NAME } from "../../config/awsParams";

interface FormAddPortefeuilleProps {
  actifs: Actif[];
  users: User[];
  closeModalPortefeuille: () => void;
}
const FormAddPortefeuille = ({
  actifs,
  users,
  closeModalPortefeuille,
}: FormAddPortefeuilleProps) => {
  const queryClient = useQueryClient();
  const { client, user } = useAuth();
  const [checked, setChecked] = useState<boolean>(false);
  const [selectedactifs, setSelectedActifs] = useState<Actif[] | null>(null);
  const [selectedusers, setSelectedUsers] = useState<User[] | null>(null);
  const [actif_ids, setActifIds] = useState<number[]>([]);
  const [user_ids, setUserIds] = useState<number[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();









  const handleSelectChangeActifs = (e) => {
    setSelectedActifs(e.value);
    if (e.value.length !== 0) {
      const selectedValues = e.value.map((option) => option.id);
      setActifIds(selectedValues);
    } else {
      setActifIds([]);
    }
  };

  const handleSelectChangeUtilisateurs = (e) => {
    setSelectedUsers(e.value);
    if (e.value.length !== 0) {
      const selectedValues = e.value.map((option) => option.id);
      setUserIds(selectedValues);
    } else {
      setUserIds([]);
    }
  };

  const ActifsTemplate = (option) => {
    return (
      <div className="flex items-center space-x-2">
        <img
          src={
            option.photo_actif
              ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/actif_photos/${option?.photo_actif}`
              : "/images/folder 1.png"
          }
          className="w-5 h-5"
        />
        <span>{option.nom_actif}</span>
      </div>
    );
  };
  const UsersTemplate = (option) => {
    return (
      <div className="flex space-x-2">
        <img
          className="object-cover w-5 h-5 rounded-full"
          src={
            option?.photo_user
              ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/${option?.photo_user}`
              : `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/profile.png`
          }
        />
        <div className="text-left rtl:text-right">
          <h1 className="text-sm font-semibold text-gray-700 capitalize ">
            {`${option?.first_name}  ${option?.last_name} `}
          </h1>
        </div>
      </div>
    );
  };
  const onSubmit = async (data) => {
    try {
      if (actif_ids && actif_ids.length) {
        let portefeuilleData = {};
        if (user_ids && user_ids.length) {
          portefeuilleData = {
            nom_portefeuille: data.nom_portefeuille,
            restricted_access: checked,
            env_client_id: client.id,
            user_id: user.id,
            actif_ids: actif_ids,
            user_ids: user_ids,
          };
        } else {
          portefeuilleData = {
            nom_portefeuille: data.nom_portefeuille,
            restricted_access: checked,
            user_id: user.id,
            env_client_id: client.id,
            actif_ids: actif_ids,
          };
        }
        setLoading(true);
        await portefeuillesService.post(portefeuilleData).then(() => {
          setLoading(false);
          showToast("success", "Portefeuille ajouté avec succès");
          reset();
          queryClient.refetchQueries({
            queryKey: ["portefeuilles"],
          });

          setActifIds([]);
          setUserIds([]);
          closeModalPortefeuille();
        });
      } else {
        showToast("info", "Veuillez choisir le(s) actif(s)");
      }
    } catch (e) {
      setLoading(true);
      console.log("Error while fetching", e);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="grid grid-cols-6 gap-6">
          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="nom_portefeuille"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Nom *
            </label>
            <input
              type="text"
              name="nom_portefeuille"
              id="nom_portefeuille"
              placeholder="Saisir nom"
              className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("nom_portefeuille", {
                required: true,
              })}
            />
            {errors.nom_portefeuille && (
              <span className="bg-red-100 text-red-800 text-sm font-medium mr-2 mt-2  px-2 py-1 rounded ">
                champs obligatoire
              </span>
            )}
          </div>
          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="actifs"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Choisir actif(s) *
            </label>

            <MultiSelect
              className="my-3 border border-gray-300 text-gray-900 font-bold text-xl rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 w-full"
              placeholder="Sélectionner vos actifs..."
              itemTemplate={ActifsTemplate}
              options={actifs}
              value={selectedactifs}
              onChange={handleSelectChangeActifs}
              optionLabel="nom_actif"
              display="chip"
              filter
            />
          </div>
          <div className="col-span-6 sm:col-span-6">
            <div
              className="flex items-center p-4 mb-4 text-sm text-blue-800 rounded-lg bg-blue-50 "
              role="alert"
            >
              <svg
                className="flex-shrink-0 inline w-4 h-4 mr-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
              </svg>
              <span className="sr-only">Info</span>
              <div className="text-md">
                Si vous cochez ce bouton.{" "}
                <strong>Votre portefeuille sera avec droits d'accès</strong>.
              </div>
            </div>

            <div className="flex items-center space-x-2">
              <InputSwitch
                checked={checked}
                onChange={(e) => setChecked(e.value)}
              />
              <span className="block text-lg font-bold leading-6 text-gray-900">
                Portefeuille avec droits d'accès
              </span>
            </div>
          </div>

          {checked && (
            <div className="col-span-6 sm:col-span-6">
              <label
                htmlFor="utilisateurs"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Choisir le(s) utilisateur(s)
              </label>

              <MultiSelect
                className="my-3 border border-gray-300 text-gray-900 font-bold text-xl rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 w-full"
                placeholder="Sélectionner vos utilisateurs..."
                itemTemplate={UsersTemplate}
                options={users}
                value={selectedusers}
                onChange={handleSelectChangeUtilisateurs}
                optionLabel="first_name"
                display="chip"
                filter
              />
            </div>
          )}
        </div>
        <p className=" text-lg font-thin my-4">* obligatoire</p>

        <div className="flex justify-end">
          <button
            type="submit"
            className="text-white mt-5  bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
          >
            Ajouter
          </button>
        </div>
      </form>
      {loading && <Loading />}
    </>
  );
};

export default FormAddPortefeuille;
